import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import headerLogo from "./../../Registration/img/header-logo.svg";
import forgotPasswordIcon from "./../../Registration/img/forgot-password.svg";
import eyeIconForm from "./../../Registration/img/eye-icon-form.svg";
import eyeSlashIconForm from "./../../Registration/img/eye-slash-icon-form.svg";
import { translate } from 'react-i18next';
import { request } from '../../../config';

class ChangePassword extends Component {
    state = {
        customerType: 'Individual',
        isPasswordVisibility: false,
        isRepeatPasswordVisibility: false,
        isDisabled: true,
        feedbackMessage: null,
        allRequirementsMet: false,
        passwordRequirements: {
            hasLength: false,
            hasUppercase: false,
            hasLowercase: false,
            hasNumber: false,
            hasSpecial: false,
        }
    }

    backLogin = () => {
        if (this.state.customerType === 'Juridical') {
            this.props.history.push('/login/juridical/mobile');
        }
        else {
            this.props.history.push('/login/individual/mobile');
        }
    }

    validatePasswordRequirements = (password) => {
        const requirements = {
            hasLength: password.length >= 8,
            hasUppercase: /[A-Z]/.test(password),
            hasLowercase: /[a-z]/.test(password),
            hasNumber: /[0-9]/.test(password),
            hasSpecial: /[!@#$%^&*()_+\-=[\]{}|;:'",./<>?\\`~]/.test(password),
        };
        return requirements;
    }

    checkIsNotNull = () => {
        this.setState({ feedbackMessage: null });
        const password = this.password.value.trim();
        const repeatPassword = this.repeatPassword.value.trim();

        const requirements = this.validatePasswordRequirements(password);
        const allRequirementsMet = Object.values(requirements).every(req => req === true);

        if (password !== "" && repeatPassword !== "" && password === repeatPassword && allRequirementsMet) {
            this.setState({ isDisabled: false, passwordRequirements: requirements, allRequirementsMet });
        }
        else {
            this.setState({ isDisabled: true, passwordRequirements: requirements, allRequirementsMet });
        }
    }

    setPasswordVisibility = (name) => {
        this.setState({ [name]: !this.state[name] });
    }

    setPassword = (event) => {
        event.preventDefault();
        let changePasswordRequestBody = {
            password: this.password.value,
            repeatPassword: this.repeatPassword.value,
            verifyToken: this.props.location.state?.verifyToken,
            token: this.props.location.state?.token,
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
        }
        fetch(request("register/changeForgotPassword" + this.state.customerType + "V2", changePasswordRequestBody))
            .then(res => res.json())
            .then((changePasswordResponse) => {
                if (changePasswordResponse.status.statusCode === 1) {
                    if (this.state.customerType === 'Juridical') {
                        this.props.history.push('/login/juridical/mobile/forgot-password/4', {});
                    }
                    else {
                        this.props.history.push('/login/individual/mobile/forgot-password/4', {});
                    }
                }
                else {
                    this.setState({ feedbackMessage: this.props.t(changePasswordResponse.status.statusCode) });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    componentDidMount() {
        if (this.props.location.state === undefined) {
            if (this.props.match.url === '/login/juridical/mobile/forgot-password/3') {
                this.props.history.push('/login/juridical/mobile/forgot-password/1');
            }
            else {
                this.props.history.push('/login/individual/mobile/forgot-password/1');
            }
        }
        else {
            if (this.props.match.url === '/login/juridical/mobile/forgot-password/3') {
                this.setState({ customerType: 'Juridical' });
            }
            else if (this.props.match.url === '/login/individual/mobile/forgot-password/3') {
                this.setState({ customerType: 'Individual' });
            }
        }
    }

    render() {
        let { feedbackMessage, isDisabled, isPasswordVisibility, isRepeatPasswordVisibility, passwordRequirements } = this.state;
        let { t } = this.props;
        const requiredMap = {
            hasLength: t('At least 8 characters'),
            hasUppercase: t('One uppercase letter'),
            hasLowercase: t('One lowercase letter'),
            hasNumber: t('One number'),
            hasSpecial: t('One special character'),
        };
        return (
            <div className="registration">
                <Link to="/">
                    <img src={headerLogo} className="registration-logo" alt="headerLogo" />
                </Link>
                <form className="registration-container registration-container--top-border">
                    <h2 className="registration-container-title">{t('forget password')}</h2>
                    <p className="registration-container-description">{t('enter your new password')}</p>
                    <img src={forgotPasswordIcon} className="registration-container-icon" alt="forgotPasswordIcon" />
                    <div className="registration-container-form-grid">
                        <div className="registration-container-form-group registration-container-form-group-grid">
                            <label className="registration-container-form-group-label">{t('password')}</label>
                            <div className="registration-container-form-group-box">
                                <input type={isPasswordVisibility === false ? "password" : "text"} className="registration-container-form-group-box-input" placeholder={t('enter the password')} ref={(input) => { this.password = input }} onInput={this.checkIsNotNull} />
                                <div className="registration-container-form-group-box-icon" onClick={this.setPasswordVisibility.bind(this, 'isPasswordVisibility')}>
                                    {
                                        isPasswordVisibility === false ?
                                            <img src={eyeIconForm} className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__password" alt="" />
                                            :
                                            <img src={eyeSlashIconForm} className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__password-slash" alt="" />
                                    }
                                </div>
                            </div>
                            <div style={{ marginTop: '16px' }}>
                                {Object.entries(requiredMap).map(([key, label]) => (
                                    <div key={key} className="registration-container-form-group-label" style={{ display: 'flex', alignItems: 'center', color: passwordRequirements[key] ? '#16A34A' : '#9CA3AF' }}>
                                        <span style={{ marginRight: '8px' }}>{passwordRequirements[key] ? '✓' : '𐤏'}</span>
                                        <span>{label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="registration-container-form-group registration-container-form-group-grid">
                            <label className="registration-container-form-group-label">{t('repeat password')}</label>
                            <div className="registration-container-form-group-box">
                                <input type={isRepeatPasswordVisibility === false ? "password" : "text"} className="registration-container-form-group-box-input" placeholder={t('enter the password again')} ref={(input) => { this.repeatPassword = input }} onInput={this.checkIsNotNull} disabled={!this.state.allRequirementsMet} />
                                <div className="registration-container-form-group-box-icon" onClick={this.setPasswordVisibility.bind(this, 'isRepeatPasswordVisibility')}>
                                    {
                                        isRepeatPasswordVisibility === false ?
                                            <img src={eyeIconForm} className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__password" alt="" />
                                            :
                                            <img src={eyeSlashIconForm} className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__password-slash" alt="" />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="registration-container-validation-feedback">
                        {
                            feedbackMessage ? <p className="header-sign-section-container-form-validation-feedback-message">{feedbackMessage}</p> : null
                        }
                    </div>
                    <div className="registration-container-footer">
                        <button type="button" className="registration-container-footer-button registration-container-footer-button--left" onClick={this.backLogin}>{t('back')}</button>
                        <button className="registration-container-footer-button registration-container-footer-button--right" disabled={isDisabled} onClick={this.setPassword}>{t('next')}</button>
                    </div>
                </form>
            </div>
        )
    }
}
export default translate("translation")(ChangePassword);